export default __webpack_public_path__ + "static/assets/med_pill_round_in_L2_solid_l_01_f_mask.de40f24a.png";